export class JobInitiationResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "jobId",
            "baseName": "jobId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return JobInitiationResponse.attributeTypeMap;
    }
    constructor() {
    }
}
